import React from "react";
import "./PrivacyPolicy.css";

export default function PrivacyPolicy() {
    return (
        <div className="privacy-container">

            <h1>Privacy Policy</h1>
            <p className="last-updated">Last updated: January 29, 2026</p>

            <section>
                <p>
                    This Privacy Policy describes Our policies and procedures on the
                    collection, use and disclosure of Your information when You use the
                    Service and tells You about Your privacy rights and how the law protects
                    You.
                </p>

                <p>
                    We use Your Personal Data to provide and improve the Service. By using
                    the Service, You agree to the collection and use of information in
                    accordance with this Privacy Policy. This Privacy Policy has been
                    created with the help of the Privacy Policy Generator.
                </p>
            </section>

            <section>
                <h2>Interpretation and Definitions</h2>

                <h3>Interpretation</h3>
                <p>
                    The words whose initial letters are capitalized have meanings defined
                    under the following conditions. The following definitions shall have
                    the same meaning regardless of whether they appear in singular or in
                    plural.
                </p>

                <h3>Definitions</h3>
                <p>For the purposes of this Privacy Policy:</p>

                <ul>
                    <li><strong>Account</strong> means a unique account created for You to access our Service or parts of our Service.</li>

                    <li><strong>Affiliate</strong> means an entity that controls, is controlled by, or is under common control with a party, where “control” means ownership of 50% or more of the shares, equity interest or other securities entitled to vote for election of directors or other managing authority.</li>

                    <li><strong>Company</strong> (referred to as either “the Company”, “We”, “Us” or “Our”) refers to One Global Marketplace, Bengaluru, Karnataka.</li>

                    <li><strong>Cookies</strong> are small files that are placed on Your computer, mobile device or any other device by a website, containing the details of Your browsing history on that website among its many uses.</li>

                    <li><strong>Country</strong> refers to: Karnataka, India.</li>

                    <li><strong>Device</strong> means any device that can access the Service such as a computer, a cell phone or a digital tablet.</li>

                    <li><strong>Personal Data</strong> (or “Personal Information”) is any information that relates to an identified or identifiable individual.</li>

                    <li>We use “Personal Data” and “Personal Information” interchangeably unless a law uses a specific term.</li>

                    <li><strong>Service</strong> refers to the Website.</li>

                    <li><strong>Service Provider</strong> means any natural or legal person who processes the data on behalf of the Company.</li>

                    <li><strong>Usage Data</strong> refers to data collected automatically, either generated by the use of the Service or from the Service infrastructure itself.</li>

                    <li><strong>Website</strong> refers to One Global Marketplace, accessible from https://www.oneglobalmarketplace.com.</li>

                    <li><strong>You</strong> means the individual accessing or using the Service, or the company, or other legal entity on behalf of which such individual is accessing or using the Service.</li>
                </ul>
            </section>

            <section>
                <h2>Collecting and Using Your Personal Data</h2>

                <h3>Types of Data Collected</h3>

                <h4>Personal Data</h4>
                <p>
                    While using Our Service, We may ask You to provide Us with certain
                    personally identifiable information that can be used to contact or
                    identify You. Personally identifiable information may include, but is
                    not limited to:
                </p>

                <ul>
                    <li>Email address</li>
                    <li>First name and last name</li>
                    <li>Phone number</li>
                </ul>

                <h4>Usage Data</h4>
                <p>Usage Data is collected automatically when using the Service.</p>

                <p>
                    Usage Data may include information such as Your Device's Internet
                    Protocol address (e.g. IP address), browser type, browser version, the
                    pages of our Service that You visit, the time and date of Your visit,
                    the time spent on those pages, unique device identifiers and other
                    diagnostic data.
                </p>

                <p>
                    When You access the Service by or through a mobile device, We may
                    collect certain information automatically, including, but not limited
                    to, the type of mobile device You use, Your mobile device's unique ID,
                    the IP address of Your mobile device, Your mobile operating system, the
                    type of mobile Internet browser You use, unique device identifiers and
                    other diagnostic data.
                </p>

                <p>
                    We may also collect information that Your browser sends whenever You
                    visit Our Service or when You access the Service by or through a mobile
                    device.
                </p>
            </section>

            <section>
                <h2>Tracking Technologies and Cookies</h2>

                <p>
                    We use Cookies and similar tracking technologies to track the activity
                    on Our Service and store certain information. Tracking technologies We
                    use include beacons, tags, and scripts to collect and track information
                    and to improve and analyze Our Service.
                </p>

                <p>
                    Cookies can be “Persistent” or “Session” Cookies. Persistent Cookies
                    remain on Your personal computer or mobile device when You go offline,
                    while Session Cookies are deleted as soon as You close Your web browser.
                </p>

                <p>
                    Where required by law, we use non-essential cookies only with Your
                    consent. You can withdraw or change Your consent at any time using Your
                    browser or device settings.
                </p>

                <h4>Necessary / Essential Cookies</h4>
                <p><strong>Type:</strong> Session Cookies</p>
                <p><strong>Administered by:</strong> Us</p>
                <p>
                    <strong>Purpose:</strong> These Cookies are essential to provide You
                    with services available through the Website and to enable You to use
                    some of its features.
                </p>

                <h4>Cookies Policy / Notice Acceptance Cookies</h4>
                <p><strong>Type:</strong> Persistent Cookies</p>
                <p><strong>Administered by:</strong> Us</p>

                <h4>Functionality Cookies</h4>
                <p><strong>Type:</strong> Persistent Cookies</p>
                <p><strong>Administered by:</strong> Us</p>
            </section>

            <section>
                <h2>Use of Your Personal Data</h2>

                <ul>
                    <li>To provide and maintain our Service</li>
                    <li>To manage Your Account</li>
                    <li>For the performance of a contract</li>
                    <li>To contact You</li>
                    <li>To provide news and offers</li>
                    <li>To manage Your requests</li>
                    <li>For business transfers</li>
                    <li>For other purposes such as analytics and improvements</li>
                </ul>
            </section>

            <section>
                <h2>Retention of Your Personal Data</h2>

                <p>
                    The Company will retain Your Personal Data only for as long as is
                    necessary for the purposes set out in this Privacy Policy.
                </p>

                <p>
                    User Accounts: retained for the duration of your account relationship
                    plus up to 24 months after account closure.
                </p>

                <p>
                    Customer Support Data and Chat transcripts: up to 24 months.
                </p>

                <p>
                    Usage Data and server logs: up to 24 months for analytics and security.
                </p>
            </section>

            <section>
                <h2>Transfer of Your Personal Data</h2>

                <p>
                    Your information may be transferred to and maintained on computers
                    located outside of Your jurisdiction where data protection laws may
                    differ.
                </p>

                <p>
                    The Company will take all steps reasonably necessary to ensure that
                    Your data is treated securely and in accordance with this Privacy
                    Policy.
                </p>
            </section>

            <section>
                <h2>Delete Your Personal Data</h2>

                <p>
                    You have the right to delete or request assistance in deleting Your
                    Personal Data.
                </p>

                <p>
                    You may update, amend, or delete Your information by signing in to Your
                    Account or by contacting Us.
                </p>
            </section>

            <section>
                <h2>Disclosure of Your Personal Data</h2>

                <p><strong>Business Transactions</strong></p>
                <p>
                    If the Company is involved in a merger, acquisition or asset sale, Your
                    Personal Data may be transferred.
                </p>

                <p><strong>Law enforcement</strong></p>
                <p>
                    The Company may disclose Your Personal Data if required by law.
                </p>
            </section>

            <section>
                <h2>Security of Your Personal Data</h2>

                <p>
                    The security of Your Personal Data is important to Us, but no method of
                    transmission or storage is 100% secure.
                </p>
            </section>

            <section>
                <h2>Children's Privacy</h2>

                <p>
                    Our Service does not address anyone under the age of 16. We do not
                    knowingly collect Personal Data from children.
                </p>
            </section>

            <section>
                <h2>Links to Other Websites</h2>

                <p>
                    We have no control over and assume no responsibility for third-party
                    websites.
                </p>
            </section>

            <section>
                <h2>Changes to this Privacy Policy</h2>

                <p>
                    We may update Our Privacy Policy from time to time. Changes are
                    effective when posted.
                </p>
            </section>

            <section className="contact-box">
                <h2>Contact Us</h2>
                <p>
                    If you have any questions about this Privacy Policy, You can contact us
                    by visiting:
                </p>
                <a href="https://www.oneglobalmarketplace.com/contact">
                    https://www.oneglobalmarketplace.com/contact
                </a>
            </section>

        </div>
    );
}
